import { ActionSelect, useAccess } from '../parts/index.js';
import { useKeeperChooser } from './KeeperView.js';
// The manager-view chooser (R6, B55) in U20's look (B202, milestone 5 check 5), drawn from
// RecentAndQuestions.dc.html's filter strip: "Viewing as ▾", only if you have a report.
//
// No change of function from the chooser it replaces in Recent.tsx: the same reports (from
// GET /api/reports, which the database answers), the same value ('' is myself), the same
// sentence saying what the view is and is not. A manager sees exactly the report's view,
// inherited and read-only: not their unsorted mail (R26), not their questions (B55), and
// nothing the manager's own group reads that the report's does not. It draws nothing for
// someone with no report, which is almost everyone (R5: no control for a thing you cannot do).
import type { ReportView } from '../rails.js';
import '../rails-admin.css';

export function ViewAsChooser({ reports, viewAs, onChange }: { reports: ReportView[]; viewAs: string; onChange: (principalId: string) => void }) {
  const keeper = useAccess()?.person.keeper;
  const keeperChooser = useKeeperChooser();
  if (keeper || keeperChooser || reports.length === 0) return null;
  const looking = reports.find((r) => r.principalId === viewAs) ?? null;
  return (
    <div className="rails-viewas">
      <label className={looking ? 'tg on' : 'tg'}>
        Viewing as
        <ActionSelect reading value={viewAs} onChange={(e) => onChange(e.target.value)} aria-label="view as">
          <option value="">myself</option>
          {reports.map((r) => <option key={r.principalId} value={r.principalId}>{r.displayName}</option>)}
        </ActionSelect>
      </label>
      {looking
        ? <p className="note">You are seeing exactly what {looking.displayName.split(' ')[0]} sees: not their unsorted mail, not their questions, and nothing your own group reads that theirs does not. Nothing can be changed from here.</p>
        : <p className="note">Only because you manage someone: their view, read-only.</p>}
    </div>
  );
}
